__turbopack_context__.v({
  "tabsTabList": "tabModuleDesktop-module-scss-module__0paDnq__tabsTabList",
});
